import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {

  constructor() { }

  private readonly STORAGE_KEY = 'selectedDeliveryDetails';

  location = {
    lat: 0,
    lon: 0,
  };

  setItem(setItem: any, data: any) {
    localStorage.setItem(setItem, data);
  }

  getItem(getItem: any) {
    return localStorage.getItem(getItem);
  }

  removeItem(remItem: any) {
    localStorage.removeItem(remItem);
  }

  removeAllItem() {
    localStorage.clear();
  }

  checkLength() {
    return localStorage.length;
  }

  setLocation(lat: any, lon: any) {
    this.location = { lat, lon };
  }

  getLocation() {
    return this.location;
  }

  getDeliveryDetails(): { pincode: number; latitude: number; longitude: number } | null {
    const data = localStorage.getItem(this.STORAGE_KEY);
    return data ? JSON.parse(data) : null;
  }

  setDeliveryDetails(details: { pincode: number; latitude: number; longitude: number }) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(details));
  }

}